module.exports = __webpack_public_path__ + "static/media/about-certificate-img10.a9e639fd.jpg";